module.exports = __webpack_public_path__ + "img/meJoeKev.031db22c.jpg";